import { type FormEvent, useId, useRef, useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";

const logoWhiteUrl = "/logo-dark.png";
const logoDarkUrl = "/logo-dark.png";

function ResetBadgeIcon() {
  const suffix = useId().replace(/:/g, "");
  const filterId = `reset-badge-filter-${suffix}`;
  const paint0Id = `reset-badge-paint0-${suffix}`;
  const paint1Id = `reset-badge-paint1-${suffix}`;

  return (
    <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="0.5" y="0.5" width="87" height="87" rx="43.5" fill={`url(#${paint0Id})`} />
      <rect x="0.5" y="0.5" width="87" height="87" rx="43.5" stroke={`url(#${paint1Id})`} />
      <g filter={`url(#${filterId})`}>
        <rect x="16" y="16" width="56" height="56" rx="28" fill="white" />
        <rect x="16.5" y="16.5" width="55" height="55" rx="27.5" stroke="#E2E4E9" />
        <path
          d="M46.1016 46.3646V48.5591C45.1512 48.2231 44.1342 48.12 43.1357 48.2586C42.1373 48.3971 41.1867 48.7732 40.3638 49.3552C39.5408 49.9373 38.8695 50.7083 38.4063 51.6035C37.943 52.4987 37.7014 53.492 37.7016 54.5L35.6016 54.499C35.6012 53.2168 35.8944 51.9516 36.4587 50.8002C37.0229 49.6489 37.8432 48.642 38.8568 47.8567C39.8703 47.0714 41.0502 46.5285 42.306 46.2697C43.5617 46.0109 44.8601 46.043 46.1016 46.3636V46.3646ZM44.0016 45.05C40.5208 45.05 37.7016 42.2308 37.7016 38.75C37.7016 35.2693 40.5208 32.45 44.0016 32.45C47.4823 32.45 50.3016 35.2693 50.3016 38.75C50.3016 42.2308 47.4823 45.05 44.0016 45.05ZM44.0016 42.95C46.3221 42.95 48.2016 41.0705 48.2016 38.75C48.2016 36.4295 46.3221 34.55 44.0016 34.55C41.6811 34.55 39.8016 36.4295 39.8016 38.75C39.8016 41.0705 41.6811 42.95 44.0016 42.95ZM50.3016 49.25V46.1H52.4016V49.25H55.5516V51.35H52.4016V54.5H50.3016V51.35H47.1516V49.25H50.3016Z"
          fill="#525866"
        />
      </g>
      <defs>
        <filter
          id={filterId}
          x="12"
          y="14"
          width="64"
          height="64"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="2" />
          <feGaussianBlur stdDeviation="2" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.105882 0 0 0 0 0.109804 0 0 0 0 0.113725 0 0 0 0.04 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape" />
        </filter>
        <linearGradient id={paint0Id} x1="44" y1="0" x2="44" y2="88" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4E5E7" stopOpacity="0.48" />
          <stop offset="1" stopColor="#F7F8F8" stopOpacity="0" />
          <stop offset="1" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
        <linearGradient id={paint1Id} x1="44" y1="0" x2="44" y2="88" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E4E5E7" />
          <stop offset="0.765625" stopColor="#E4E5E7" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
}

function HeartBadgeIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 32 33" fill="none">
      <path
        d="M30 13.512C30 22.262 17.0262 29.3445 16.4737 29.637C16.3281 29.7153 16.1654 29.7563 16 29.7563C15.8346 29.7563 15.6719 29.7153 15.5262 29.637C14.9738 29.3445 2 22.262 2 13.512C2.00232 11.4572 2.81958 9.48735 4.27248 8.03444C5.72539 6.58154 7.69528 5.76428 9.75 5.76196C12.3313 5.76196 14.5912 6.87196 16 8.74821C17.4088 6.87196 19.6688 5.76196 22.25 5.76196C24.3047 5.76428 26.2746 6.58154 27.7275 8.03444C29.1804 9.48735 29.9977 11.4572 30 13.512Z"
        fill="currentColor"
      />
    </svg>
  );
}

function EyeOpenIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256" fill="none">
      <path fill="currentColor" d="M247.31 124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57 61.26 162.88 48 128 48S61.43 61.26 36.34 86.35C17.51 105.18 9 124 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208s66.57-13.26 91.66-38.34c18.83-18.83 27.3-37.61 27.65-38.4a8 8 0 0 0 0-6.5M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.5 133.5 0 0 1 25 128a133.3 133.3 0 0 1 23.07-30.75C70.33 75.19 97.22 64 128 64s57.67 11.19 79.93 33.25A133.5 133.5 0 0 1 231.05 128c-7.21 13.46-38.62 64-103.05 64m0-112a48 48 0 1 0 48 48a48.05 48.05 0 0 0-48-48m0 80a32 32 0 1 1 32-32a32 32 0 0 1-32 32" />
    </svg>
  );
}

function EyeCloseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" width="100%" preserveAspectRatio="xMidYMid meet" viewBox="0 0 256 256" fill="none">
      <path fill="currentColor" d="M228 175a8 8 0 0 1-10.92-3l-19-33.2A123.2 123.2 0 0 1 162 155.46l5.87 35.22a8 8 0 0 1-6.58 9.21a8.4 8.4 0 0 1-1.29.11a8 8 0 0 1-7.88-6.69l-5.77-34.58a133 133 0 0 1-36.68 0l-5.77 34.58A8 8 0 0 1 96 200a8.4 8.4 0 0 1-1.32-.11a8 8 0 0 1-6.58-9.21l5.9-35.22a123.2 123.2 0 0 1-36.06-16.69L39 172a8 8 0 1 1-13.94-8l20-35a153.5 153.5 0 0 1-19.3-20a8 8 0 1 1 12.46-10c16.6 20.54 45.64 45 89.78 45s73.18-24.49 89.78-45a8 8 0 1 1 12.44 10a153.5 153.5 0 0 1-19.3 20l20 35a8 8 0 0 1-2.92 11" />
    </svg>
  );
}

function CautionIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 16 16" fill="none" className="flex h-4 w-4 shrink-0">
      <path d="M8 14C4.6862 14 2 11.3138 2 8C2 4.6862 4.6862 2 8 2C11.3138 2 14 4.6862 14 8C14 11.3138 11.3138 14 8 14ZM7.4 9.8V11H8.6V9.8H7.4ZM7.4 5V8.6H8.6V5H7.4Z" fill="#868C98" />
    </svg>
  );
}

const PASSWORD_REGEX = /^(?=.*[A-Z])(?=.*\d).{8,}$/;

export function ResetPasswordPage() {
  const { user, updatePassword } = useAuth();

  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const passwordRef = useRef<HTMLInputElement>(null);
  const confirmRef = useRef<HTMLInputElement>(null);

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(null);

    const password = passwordRef.current?.value ?? "";
    const confirm = confirmRef.current?.value ?? "";

    if (!password || !confirm) {
      setError("Please fill in all fields.");
      return;
    }

    if (password !== confirm) {
      setError("Passwords do not match.");
      return;
    }

    if (!PASSWORD_REGEX.test(password)) {
      setError("Password must contain 1 uppercase letter, 1 number, and be at least 8 characters.");
      return;
    }

    setSubmitting(true);
    const { error: updateError } = await updatePassword(password);
    setSubmitting(false);

    if (updateError) {
      setError(updateError);
      return;
    }

    setSuccess(true);
  };

  return (
    <div className="relative isolate flex min-h-screen flex-col">
      <main className="flex flex-1 flex-col">
        <section className="bg-transparent text-[#1f0a18]">
          <div className="grid min-h-screen grid-cols-[1fr_1fr] grid-rows-[auto] auto-cols-fr max-[991px]:grid-cols-[1fr]">
            <div className="relative flex flex-col px-[var(--site-margin)]">
              <div className="mt-5 max-[991px]:absolute max-[991px]:inset-x-[var(--site-margin)] max-[991px]:top-0 max-[991px]:z-[900]">
                <Link to="/" className="inline-block max-w-full pl-0" aria-label="BollyRhythm">
                  <img loading="lazy" src={logoWhiteUrl} alt="BollyRhythm" className="hidden max-w-full align-middle max-[991px]:block" style={{ width: "10rem" }} />
                  <img loading="lazy" src={logoDarkUrl} alt="BollyRhythm" className="inline-block max-w-full align-middle max-[991px]:!hidden" style={{ width: "10rem" }} />
                </Link>
              </div>

              <div className="flex flex-1 flex-col items-center justify-center">
                <div className="mb-5 flex flex-col items-center justify-start gap-1 text-center">
                  <div className="h-[95px] before:content-[' '] before:table before:col-start-1 before:col-end-2 before:row-start-1 before:row-end-2 after:content-[' '] after:table after:col-start-1 after:col-end-2 after:row-start-1 after:row-end-2 after:clear-both">
                    <ResetBadgeIcon />
                  </div>
                  <h1 className="m-0 font-display text-[clamp(1.25rem,1.0357rem+1.0714vw,2rem)] font-semibold leading-[1.2]">Reset Your Password</h1>
                  <div className="text-neutral text-base">
                    {user?.email ? `Enter a new password for ${user.email}` : "Enter your new password"}
                  </div>
                </div>

                <div className="mb-[15px] w-full max-w-[24rem]">
                  {success ? (
                    <div className="rounded-[var(--radius-main)] bg-[#cef5ca] p-2.5 text-center text-sm text-[#114e0b]" role="status">
                      Password Updated! Go to{" "}
                      <Link to="/app/dashboard/home" className="text-[#762a5c] underline">
                        Dashboard
                      </Link>
                    </div>
                  ) : (
                    <form className="m-0" onSubmit={handleSubmit}>
                      {error && (
                        <div className="mt-2.5 rounded-[var(--radius-main)] bg-[#f8e4e4] p-2.5 text-center text-sm text-[#3b0b0b]" role="alert">
                          {error}
                        </div>
                      )}

                      <label htmlFor="reset_input_password" className="mb-1 block text-sm font-medium text-neutral-darker">
                        <strong className="font-semibold">New Password*</strong>
                      </label>
                      <div className="relative mb-3">
                        <input
                          ref={passwordRef}
                          className="mb-0 w-full min-h-12 appearance-none rounded-[0.38rem] border border-neutral-lighter bg-transparent px-4 py-2 pl-10 font-sans text-base leading-none text-[#333333] placeholder:text-[#868c98] placeholder:text-sm focus:border-[color-mix(in_srgb,var(--color-pink-dark)_30%,var(--color-neutral-lighter))] focus:outline-none"
                          maxLength={256}
                          name="password"
                          placeholder="• • • • • • • • • • "
                          type={showPassword ? "text" : "password"}
                          id="reset_input_password"
                          autoComplete="new-password"
                          required
                          style={{ backgroundImage: 'url("https://cdn.prod.website-files.com/686229256a807206c1874545/687a1ddabbbe13359dbfe985_lock-2-line.svg")', backgroundPosition: '12px', backgroundRepeat: 'no-repeat', backgroundSize: 'auto' }}
                        />
                        <button
                          type="button"
                          className="absolute top-1/2 right-0 flex -translate-y-1/2 -translate-x-3 cursor-pointer border-0 bg-transparent p-0 text-current focus-visible:outline-[0.125rem] focus-visible:outline-[#4d65ff] focus-visible:outline-offset-[0.125rem]"
                          aria-label={showPassword ? "Hide password" : "Show password"}
                          onClick={() => setShowPassword((c) => !c)}
                        >
                          <span className={`flex w-5 ${showPassword ? "" : "!hidden"}`}>
                            <EyeOpenIcon />
                          </span>
                          <span className={`flex w-5 ${showPassword ? "!hidden" : ""}`}>
                            <EyeCloseIcon />
                          </span>
                        </button>
                      </div>

                      <label htmlFor="reset_input_confirm" className="mb-1 block text-sm font-medium text-neutral-darker">
                        <strong className="font-semibold">Confirm Password*</strong>
                      </label>
                      <div className="relative mb-3">
                        <input
                          ref={confirmRef}
                          className="mb-0 w-full min-h-12 appearance-none rounded-[0.38rem] border border-neutral-lighter bg-transparent px-4 py-2 pl-10 font-sans text-base leading-none text-[#333333] placeholder:text-[#868c98] placeholder:text-sm focus:border-[color-mix(in_srgb,var(--color-pink-dark)_30%,var(--color-neutral-lighter))] focus:outline-none"
                          maxLength={256}
                          name="confirm_password"
                          placeholder="• • • • • • • • • • "
                          type={showPassword ? "text" : "password"}
                          id="reset_input_confirm"
                          autoComplete="new-password"
                          required
                          style={{ backgroundImage: 'url("https://cdn.prod.website-files.com/686229256a807206c1874545/687a1ddabbbe13359dbfe985_lock-2-line.svg")', backgroundPosition: '12px', backgroundRepeat: 'no-repeat', backgroundSize: 'auto' }}
                        />
                      </div>

                      <div className="flex items-center justify-start gap-1 text-xs leading-[18px]">
                        <CautionIcon />
                        <div className="select-none">Must contain 1 uppercase letter, 1 number, min. 8 characters.</div>
                      </div>

                      <div className="w-full pt-4" />
                      <button
                        type="submit"
                        className="inline-flex w-full max-w-none cursor-pointer items-center justify-center gap-2 rounded-[var(--radius-large)] border-0 bg-[#762a5c] px-8 py-4 text-center text-[clamp(1rem,0.9643rem+0.1786vw,1.125rem)] font-medium leading-none text-white whitespace-nowrap transition-transform duration-200 ease-[cubic-bezier(0.39,0.575,0.565,1)] hover:-translate-y-[5%] active:scale-95"
                        disabled={submitting}
                      >
                        {submitting ? "Please wait..." : "Update Password"}
                      </button>
                      <div className="w-full pt-4" />

                      <div className="text-center text-sm text-neutral">
                        Remember your password?{" "}
                        <Link to="/app/auth/login" className="text-[#762a5c] underline">
                          Login
                        </Link>
                      </div>
                    </form>
                  )}
                </div>
              </div>

              <div className="mb-6 text-sm text-neutral-dark">
                <div>&copy; {new Date().getFullYear()} BollyRhythm</div>
              </div>
            </div>

            <div
              className="relative m-2 flex items-center justify-center overflow-clip rounded-2xl bg-pink-darker text-center text-white max-[991px]:order-[-1] max-[991px]:bg-[length:auto] max-[991px]:bg-[0_0] max-[991px]:bg-repeat max-[991px]:!bg-none"
              style={{ backgroundImage: 'url("https://cdn.prod.website-files.com/686229256a807206c1874545/687a15da50e97523b48616d2_Auth%20Image.avif")', backgroundPosition: '50%', backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
            >
              <div className="absolute inset-[auto_auto_0%_0%] z-[1] flex text-white max-[991px]:ml-[-8vw]" style={{ height: 'clamp(12rem, 8.2857rem + 18.5714vw, 25rem)' }} />
              <div className="absolute inset-[auto_0%_0%_auto] z-[1] flex text-white max-[991px]:mr-[-8vw]" style={{ height: 'clamp(12rem, 8.2857rem + 18.5714vw, 25rem)' }} />
              <div className="mt-10 flex flex-col items-center justify-center max-[767px]:mt-20 max-[767px]:mb-6">
                <div className="flex flex-none items-center justify-center rounded-full bg-[color-mix(in_srgb,var(--color-white)_25%,transparent)] text-white" style={{ width: 'clamp(2.5rem, 2.2143rem + 1.4286vw, 3.5rem)', minWidth: 'clamp(2.5rem, 2.2143rem + 1.4286vw, 3.5rem)', minHeight: 'clamp(2.5rem, 2.2143rem + 1.4286vw, 3.5rem)', aspectRatio: '1' }}>
                  <div className="flex" style={{ width: 'clamp(1.75rem, 1.6786rem + 0.3571vw, 2rem)' }}>
                    <HeartBadgeIcon />
                  </div>
                </div>
                <div className="w-full pt-4" />
                <div className="font-display text-[clamp(1.25rem,1.0357rem+1.0714vw,2rem)] font-semibold leading-[1.2]">
                  Our Moves.
                  <br />
                  <span className="text-[#eba4d3]">Your Dance.</span>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
